import { reducerWithInitialState } from 'typescript-fsa-reducers';

import { FlashMessage } from '@pegasus/ui-flashmessages/types/flashmessage';

import { NAMESPACE } from './index';
import { addClientFlashMessage } from './actions';

export interface State {
    messages: FlashMessage[];
}

export interface ClientFlashMessagesState {
    [NAMESPACE]: {
        view: State;
    };
}

export const INITIAL_STATE: State = {
    messages: [],
};

export const reducer = reducerWithInitialState<State>(INITIAL_STATE).case(
    addClientFlashMessage,
    (state, message) => ({
        ...state,
        messages: [...state.messages, message],
    }),
);
